<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Transférer un événement</p>
        </header>
        <section class="modal-card-body">
            <form method="POST">
                <!-- Timeline field -->
                <b-field label="Ligne du temps" :type="form.errors.has('timeline') ? 'is-danger' : ''" :message="form.errors.first('timeline')">
                    <b-select v-model="form.timeline" expanded :loading="loading">
                        <template v-for="timeline in timelines">
                            <option :key="timeline.id" :value="timeline.id" v-text="timeline.title"></option>
                        </template>
                    </b-select>
                </b-field>

                <!-- Copy field -->
                <b-field>
                    <b-switch v-model="form.copy" type="is-success" :disabled="isCopyMandatory">
                        Créer une copie de l'événement
                    </b-switch>
                </b-field>
            </form>
        </section>
        <footer class="modal-card-foot">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Transférer l'événement</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import Form from 'form-backend-validation';

    export default {

        props: ['event', 'isCopyMandatory'],

        data() {
            return {
                loading: false,
                timelines: [],
                form: new Form({
                    timeline: 0,
                    copy: false,
                }),
            }
        },

        computed: {
            user() {
                return this.$store.state.account;
            },
        },
    
        methods: {

            submit() {
                this.form.post('/api/v1/events/'+this.event.id+'/transfer')
                .then( response => {
                    this.$buefy.toast.open({
                        message: 'L\'événement a été transféré',
                        type: 'is-success'
                    });

                    if (this.event.id !== response.id) {
                        this.$router.push({ name: 'events.show', params: { id: response.id }});
                    } else {
                        Bus.$emit('event.fetch');
                    }
                    this.$parent.close();
                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },

            fetchUserTimelines() {
                this.loading = true;

                axios.get('/api/v1/account/timelines?transfer')
                     .then(response => {
                        response.data.timelines.forEach(function (timeline) {
                            if (timeline.id != this.event.timeline.id) {
                                this.timelines.push(timeline);
                            }
                        }, this);

                        this.loading = false;
                });
            }
        },

        created() {
            this.fetchUserTimelines();

            this.form.populate({
                copy: this.isCopyMandatory,
            });
        }
    }
</script>